export default {
  months: {
    jan: '1月に',
    feb: '2月に',
    mar: '3月に',
    apr: '4月',
    may: '5月に',
    jun: '6月に',
    jul: '7月に',
    aug: '8月に',
    sep: '9月に',
    oct: '10月に',
    nov: '11月に',
    dec: '12月に',
  },
  all: '全体',
  day: '当日',
  one_month: '1ヶ月',
  three_months: '3ヶ月',
  six_months: '6ヶ月',
  one_year: '1年',
  increase: '増加',
  deduction: '差引',
  memo: 'メモ',
  enter_memo: 'メモを入力してください。',
  price: '金額',
  new: '最新',
  past: '過去',
  enrollment: '登録',
  re_enter: '再入力',
  registration_complete_txt: '登録が完了しました',
  registration_failed_txt: '登録が失敗しました。',
  bank_name: 'バンク名',
  locale_name: '日本語',
  sale_registration: '販売登録',
  apply: '申請',
  status: '状態',
  wallet: 'ウォレット',
  buy: '購入',
  sell: '販売',
  breakdown: '内訳',
  act_buy: '購買する',
  act_sell: '販売する',
  asset: '資産',
  select: '選択',
  no_select: '選択なし',
  account: '口座',
  balance: 'バランス',
  login: 'ログイン',
  logout: 'ログアウト',
  register: 'メンバーとして参加',
  select_cancel: 'オフ',
  cancel: 'キャンセル',
  modify: '修正',
  auto_input: '(自動入力)',
  confirm: '確定',
  look_up: '照会',
  password: 'パスワード',
  account_delete: '脱退',
  detail: '詳細',
  list_detail: '詳細詳細',
  birth: '誕生日',
  welcome: '歓迎します。',
  please_login: 'ログインしてください。',
  confirmation_login: 'ログイン時に確認できます。',
  id: 'ID',
  find_id: 'ID検索',
  find_password: 'パスワードを忘れた',
  back: '戻る',
  agreement: '規約に同意',
  info_input: '情報の入力',
  success: '完了',
  agree_msg: '同意します。',
  all_agree: '私はすべてに同意します',
  agree: '同意',
  confirm_password: 'パスワードの確認',
  repeat_password: 'パスワードを認証する',
  next: '次へ',
  before: '戻る',
  register_success: '会員登録されている。',
  verify: '確認',
  retention: '保有',
  allow: '(許可)',
  disallow: '(非許可)',
  upload_btn: 'ここにファイルをドロップしたり、クリックしてください。',
  continue_entry:
    '続けて進行する場合には [+:verification] を下に入力して下さい。',
  login_msg_1: 'コイン関連のアカウントを でご活用ください ！',
  login_msg_2:
    '私たちONEWORLDPAYを通じて取引や財布やサービスを ご利用ください。',
  login_msg_3: 'ONEWORLDPAYは、すべての環境をサポートしています。',
  cocofx_register: 'ONEWORLDPAY会員登録',
  register_msg_1: 'メンバーとして参加。 <br />利用規約に同意してください',
  register_msg_3:
    'ONEWORLDPAYアカウントは、使いやすさで、すべてのサービスへのアクセスを提供します。',
  register_msg_all:
    'すべての動きは必須と選択項目の合意も含まれており、個別に同意を選択することができます。選択項目の同意を拒否される場合もサービスは利用可能です。',
  register_title: '私は19歳以上の年齢より上です。',
  register_title_2: 'ONEWORLDPAY規約',
  register_title_3: 'ONEWORLDPAY統合サービス規約',
  register_title_4: 'ONEWORLDPAYマーケティング活用同意',
  register_title_5: '個人情報の収集と利用に同意',
  register_title_6: '位置情報の収集と利用に同意',
  register_title_7: 'プロファイル情報を追加収集に同意',
  register_title_8: '入力ONEWORLDPAYアカウント情報',
  register_title_9: '入力された情報',
  register_msg_4:
    '本規約は、会社が提供するすべてのサービスなど、共通に適用され、<br />本規約に同意することにより、そのサービスを別途利用契約を締結せずに利用することができます。',
  required: '[必須]',
  option: '[選択的]',
  otp_notice: 'OTPを有効および無効にできない状態です。',
  required_check: '必須項目にすべてチェックしてください',
  check_input: '内容をすべて入力してください。',
  register_guide: '使い方ONEWORLDPAYへ',
  register_step1: 'COCO BANKボタンをクリックします',
  register_step2: 'COCO支払うためにログイン',
  register_step3: 'ペイ/リチャージCOCO BANKログイン',
  copy: 'コピーする',
  no_account: '登録された口座がありません。',
  inviter_link: 'オススメリンク',
  register_used_account: '頻繁に使用するアカウントの登録',
  security_certification: 'セキュリティ認証',
  company: '企業',
  exact_calculation: '精算',
  profile: '会員情報',
  inquiry: 'お問い合わせ',
  announcement: 'お知らせ',
  information: '情報',
  history: '内訳',
  registration_date: '登録日',
  pay: '支払い',
  detail_search: '詳細検索',
  market: 'マーケット',
  holding: 'ホールディング',
  fee_charged: '手数料',
  type_of_charge: '手数料賦課類型',
  auto: '自動',
  manual: '手動',
  s_usdt_protocol: 'テザープロトコルの選択',
  header: {
    c2c_enroll: '購入/販売登録',
    wallet_list: '財布/内訳照会',
    wallet: '財布',
    c2c_list: '購入/販売履歴',
    no_c2c_sell_list: '販売履歴はありません。',
    transfer_list: '両替内訳',
    no_transfer_list: '両替内訳はありません。',
    withdrawal_list: '入金・出金内訳',
    my_info: '私の情報',
    home: 'メイン',
    payment_history: '支払い履歴',
    account_transfer: '口座振替',
    transfer_history: '振込内訳',
    register_used_account: '頻繁に使用するアカウントの登録',
    exchange: '両替する',
    exchange_store: '取引所',
    exchange_list: '両替内訳',
    email: 'メール',
    email_list: 'メールの履歴',
    otp: 'OTP',
    otp_list: 'OTP内訳',
    register_account: '口座を登録する',
    calculation_account_list: '精算口座リスト',
    security_certification: 'セキュリティ認証',
    exact_calculation: '精算',
    history: '内訳',
    coco_open_market: 'COCOオープンマーケット',
    information: '情報',
    my_profile: '私の情報',
    email_modify: 'メールの変更',
    password_modify: 'パスワードの変更',
    inquiry: 'お問い合わせ',
    inquiry_history: 'お問い合わせ内容',
    one_on_one_inquiry: '1:1 お問い合わせ',
    frequently_asked_questions: 'FAQ',
    announcement: 'お知らせ',
    notice: 'お知らせ',
    server_notice: 'サーバーお知らせ',
    service_center: 'サービスセンター',
    profile: '会員情報',
    company: '企業',
    account_management: '口座管理',
    do_exchange: '両替する',
    transfer: '送金',
    look_up: '照会',
    faq: 'FAQ',
    server: 'サーバー',
    email_request: 'メールお問い合わせ',
    Balance_transfer_history: '市場残高移動の履歴',
    no_balance_transfer_history: '市場残高移動の履歴がありません。',
    manual: 'マニュアル',
  },
  header_sub: {
    exchange_list: '両替内訳',
    transfer_list: '振込内訳',
  },
  footer: {
    footer_msg: 'コイン関連のアカウントをONEWORLDPAYでご活用ください！',
    footer_sub_msg:
      '私たちONEWORLDPAYを通じて取引や財布とサービスをご利用ください',
    footer_sub_msg2: 'Tip',
    footer_sub_msg3: 'ONEWORLDPAYは、すべての環境をサポートしています。',
    ICO: 'ICO',
    c2c: 'C2C取引所',
    b2c: 'B2C取引所',
    margin_exchange: 'マージン取引所',
    futures_exchange: '先物取引所',
    Binary: 'バイナリオプション',
    open_marcket: 'オープンマーケット',
    game: 'ゲーム」',
    proceed: '進行中の取引',
    public: '上場ニュース',
    direct_ex: 'ダイレクト両替',
    buy: '購買する',
    sell: '販売する',
    buy_sell: '購入/販売',
    holding_coin: '保有コイン',
    fee: '手数料のご案内',
    exchange: '取引所',
    transfer_record: '取引記録',
    Leverage: 'レバレッジ',
    live_exchange: 'ライブ取引',
    demo_exchange: 'デモ取引',
    contest: '大会',
    powerball: 'パワーボール',
    law:
      '法律：ONEWORLDPAY.COMは登録番号：70638826927（U 6 29 Railway Pde EastwoodNSW 2122）',
    law1:
      'Trading Point of Financial Instruments Ltd（オーストラリア）の全所有者であるONEWORLDPAY PTY Ltdの登録番号：70638826927商号名です。',
    law2:
      'このウェブサイトは、ONEWORLDPAY Corpによって運営されます。 ONEWORLDPAY Corpは承認番号64190  -  Auxiliary finance serviceの規制を受けており、参考番号70638826927、オーストラリアに登録されています。',
    law3:
      'ONEWORLDPAYはオーストラリアの金融商品の投資ガイドラインに従って動作します。',
    law4:
      'ref。 no。 538324 | ABN reg。 70638826927 | BA reg。 64190.居住国の法律の規定にONEWORLDPAYサービスの利用が許可されていることを確認することは完全にお客様の責任です。',
    law5: 'ONEWORLDPAYのリスク開示全文をお読みください。',
    law6:
      'ONEWORLDPAYは、米国、ベリーズ、モーリシャス、日本、アルバータ州、ブリティッシュコロンビア州、ケベック州、サスカチュワン、ハイチ、スリナム、北朝鮮、プエルトリコ、およびキプロス占領地域の住民にサービスを提供していません。',
    law7:
      '詳細については、よくある質問の規制部分を参照してください。当社のリスク開示を参考にしてください。',
    law8:
      '制限地域：Trading Point of Financial Instruments Ltdは、第三世界の国と地域への投資と付随サービスを提供していません。',
    law_warn: '危険告知：',
    law_1:
      'CFDは複雑な商品であり、レバレッジにより迅速にお金を失う危険性が高くなります。個人投資家の口座のうち69.10％がCFDを取引する際にお金を失った。',
    law_2:
      'あなたはCFDの動作を理解しているかどうかは、お金を失う危険性が高いという点を甘受することができるかについて考慮する必要があります。当社のリスク開示を参考にしてください。',
    alert_title: '参考にと注意事項',
    coco_market: 'COCOマーケット',
    ieo_market: 'IEOマーケット',
    news: 'News',
    event: 'イベント',
    platform_rental_title: '賃貸',
    education: '教育',
    online_Academy: 'オンラインアカデミー',
    offline_Academy: 'オフラインアカデミー',
    shopping_basket: 'カート',
    best_product: 'Best商品',
    order: '注文',
    my_page_title: 'マイページ',
    member_info_management: '会員情報の管理',
    order_management: '注文管理',
    my_question: '私の質問',
    one_enquiry: '1：1お問い合わせ',
    community: 'コミュニティ',
    lotto: '宝くじ',
    rock_event: 'Rock Event',
    quiz_game: 'クイズゲーム',
    ladder_game: 'はしごに乗る',
    tetris: 'テトリス',
    split_lotto: '分割ロト',
    day_Lottery: '一日宝くじ',
    attendance: '出席チェック',
    scoop_out: '埋め込み',
    forum: 'フォーラム',
  },
  b2c_exchange: {
    trading_view: 'TradingView',
    basic_chart: '基本的なグラフ',
    today_hight: '高価（当日）',
    today_row: '低価（当日）',
    tightening_strength: '締結強度',
    h24_volume: '取引量(24H)',
    h24_transaction_amount: '取引金額（24H）',
    previous_days_closing_price: '前日終値',
    auxiliary_indicator: '補助指標',
    unlimited_number: '複数の補助指標を無制限に選択することができます。 ',
    rod_type: '棒タイプ',
    chart_type: 'グラフの種類',
    market_name: '市場名',
    present_price: '現在価',
    compared_to_the_previous_day: '前日比',
    volume: '取引量',
    coin_name_and_symbol_search: 'コイン名/シンボル検索',
    event: '種目',
    asking_price_window: 'チャート',
    sell_order: '売り',
    buying_order: '買う',
    limits: '指値',
    maximum_order_price_quantity: '最大注文価格数量',
    direct_input: '直接入力',
    order_classification: '注文区分',
    order_available: '注文可能',
    order_quantity: '注文数量',
    total_order_amount: '注文総額',
    quantity_user_fee_rate: '数量利用者手数料',
    quantity_creator_fee_rate: '数量助成者手数料率',
    reset: '初期化',
    conclusion_price: '締結価',
    tightening_amount: '締結量',
    execution_time: '締結時間',
    execution_price: '締結価格',
    execution_quantity: '締結数量',
    execution_amount: '締結金額',
    order_date_and_time: 'ご注文日時',
    transaction_coin: '取引コイン',
    order_price: '注文価格',
    untraded_quantity: '未締結数量',
    state: '状態',
    current_price: '現在の価格',
    division: '区分',
    transaction_price: '取引代金',
    week52_high: '52週最高価格',
    week52_minimum: '52週最低価格',
    days_closing_price: '前日終値',
    same_day_high_price: '当日高価',
    low_price_on_the_day: '当日低価',
    average_price: '平均原価',
    cumulative_quantity: '累積量',
    cumulative_amount: '累積額',
    selection: '選択',
    minimum_ask_quantity: '最高号数量',
    save: '保存',
    accounts_that_can_be_traded: '取引可能な口座が存在しません。',
    won_pay: '原画',
    coin_order: '注文',
    asking_price: '提示価格',
    chart: 'チャート',
    quote: '見積もり',
    order_details: '注文詳細',
    account_number: '口座番号',
    moving_quantity: '移動量',
    registration_date: '登録日',
  },
  main_msg: {
    about_1_title: '世界最高の暗号通貨取引サービス',
    about_1_msg: 'コインのすべてのサービスをONEWORLDPAYがリードします。',
    about_1_1_msg:
      '世界中初めて暗号通貨コインを一つの場で購買販売がかのうです。',
    about_1_2_msg: 'ダイレクト両替に関してはONEWORLDPAYで利用可能です。',
    about_2_title: 'すぐに両替システム',
    about_2_msg:
      'ONEWORLDPAYは安定した、複数の平行マッチング技術を利用して すぐに両替ができるように高度化された設計技術を適用した 両替システムを保有しています。',
    about_3_title: '財布作成',
    about_3_msg:
      'ONEWORLDPAYは国内最高の技術陣で構成されたセキュリティの専門家が 最先端のセキュリティシステムを備えてWALLETシステムを提供しています。',
    about_4_title: '簡単に取引システム（C2C）',
    about_4_msg:
      'ONEWORLDPAYは、ユーザーフレンドリーな簡単取引システムを構築して より便利な取引を行うことができるようにしましょう。ㄴ',
    c2c_main_msg1_1:
      'ONEWORLDPAYは安定マルチ平行マッチング技術を利用して、すぐに両替が',
    c2c_main_msg1_2:
      '可能なように高度化された設計技術を適用した両替システムを保有して',
    c2c_main_msg1_3: 'ています。',
    c2c_main_msg2_1:
      'ONEWORLDPAYは国内最高の技術陣で構成されたセキュリティの専門家が',
    c2c_main_msg2_2:
      '最先端のセキュリティシステムを備えてWalletシステムを提供しています。',
    c2c_main_msg3_1:
      'ONEWORLDPAYはユーザーフレンドリーな簡単取引システムを構築しても',
    c2c_main_msg3_2: '便利な取引を行うことができます。',
  },
  toasted_msg: {
    confirm: '確認されて',
    changed: '変更されました',
    withdrawal: '引き出し',
    register: '登録されている。',
    delete: '削除された。',
    title: '通知',
    exchange: 'ダイレクト両替が正常に処理されました。',
    search: '照会しました。.',
    deposit_request: '入金の申請されました。',
    withdraw_request: '出金の申請されました',
    create_account: '開設されました.',
    modify: '修正されました。.',
    cancel: 'キャンセル',
    trade_confirm: '取引確定されました。',
    trade_reject: '取引拒否されました。',
    copy: 'コピーされました。',
    nice_msg:
      'ブラウザの設定でポップアップが許可されていない場合は、本人認証が正常に行われていません。',
    nice_title: '案内',
    nice_success: '本人認証が正常に処理されました。',
    nice_error: '本人認証を行うことができません。',
    no_transfer: '両替情報がありません。',
    email_auth: 'Eメール認証が正常に完了しました。',
    email_auth_send: '認証メールが送信されました。',
    kyc_withdraw: '口座認証に成功しました。',
    not_allow_trade: '取引無効状態です。',
    id_find_mail_send: 'IDがメールで送信されました。',
    duplicate_check: '重複IDまたはメール。',
    pay: '支払い完了しました。',
    msg_holding: 'ホールディングされた。',
    msg_read_care: '注意事項をお読みましたか？',
    answer_care: 'はい熟知しました',
    continuation: '続き',
    continue_entry:
      '続けて進行する場合には 「[+:verification]」 を下に入力して下さい。',
  },
  private: {
    market_name: 'マーケット名',
    deal_list: '販売履歴',
    app_list: '購入履歴',
    app_detail: '購入履歴の詳細',
    deal_buy_asset: '購入する資産',
    buy_price: '購入価格',
    confirmed_source_amount: '確定販売数量',
    holding_source_amount: '未確定販売数量',
    potential_source_amount: '利用可能数量',
    direct_market: 'ダイレクト両替',
    deal_enroll: '販売登録',
    app_enroll: '購入登録',
    select_market: 'マーケットの選択',
    fee_rate: '手数料',
    free: '無料',
    deal_info_input: '販売情報入力」',
    deal_source_amount: '販売数量',
    deal_price: '1個当たりの販売価格',
    deal_enroll_account: '販売登録用口座',
    account_select: '口座選択',
    direct_asset_select: '販売と購入資産を選択してください',
    please_select_asset: '資産を選択してください。',
    basic_rate: '現相場',
    direct_transfer_buy: 'すぐに購入時',
    direct_transfer_sell: 'すぐに販売時',
    direct_source_amount: '両替数量',
    direct_target_amount: '適用数量',
    direct_asset_buy: '{0}で購入',
    direct_asset_sell: '{0}で販売',
    selected_deal_info: '選択された販売情報',
    deal_source_asset_title: '購入資産',
    deal_total_source_amount: '総販売数量',
    app_info_input: '購入情報入力',
    app_amount: '購入数量',
    app_deal_price: '単価',
    pay_target_amount: 'お支払いすべき数量',
    fee: '手数料',
    fee_calc: '手数料額',
    msg_fee_calc: '{0}だけ差し引かれます。',
    app_account: '購入登録用口座',
    app_receive_account: '受ける口座を選択',
    c2c_buy_select_asset: '購入する販売公示をメインで選択してください',
    go_home: 'メインページに戻る',
    buy_calc_spread: '購入為替',
    sell_calc_spread: '販売為替',
    cs_market_asset: '資産の組',
    cs_market_basic_rate: 'マーケティング基準率',
    transfer_type: '両替タイプ',
    exchange_rate: '適用為替レート',
    submit_transfer: 'すぐに両替',
    deal_source_min_amount: '最小購入数量',
    closed_date: '終結こと',
    no_deal: '販売リストなし',
    app_price_per_quantity: '数量あたりの価格',
    app_fee_amount: '手数料合計',
    select_deal_app_list: '選択された販売の購入履歴',
    no_select_deal_app_list: 'その販売に購入履歴なし',
    transfer_source_amount: '基準資産数量',
    transfer_target_amount: '相手の資産数量',
    transfer_basic_rate: '適用マーケティング基準率',
    transfer_spread_rate: '適用スプレッド率',
    transfer_exchange_rate: '適用為替レート',
    transfer_list_detail: '両替申込内訳の詳細',
    transfer_source_asset: '基準資産',
    transfer_target_asset: '相手の資産',
    transfer_source_account_number: '基準資産口座番号',
    transfer_target_account_number: '相手の資産口座番号',
    transfer_detail_type: '交換タイプ',
    transfer_regdate: 'アプリケーションこと',
    transfer_asset_info: '{0}を{1}に{2}',
    transfer_asset_select: '交換する資産を選択してください。',
    msg_transfer_buy: '{0}で購入',
    msg_transfer_sell: '{0}で販売',
    deal_fee_amount: '売り公示者課す手数料',
  },
  wallet_page: {
    total_amount: '総出金額',
    have_asset: '保有資産',
    asset_list: '資産のリスト',
    account_list: '口座リスト',
    account_create: '口座作り',
    deposit: '入金',
    withdraw: '出金',
    deposit_list_look: '入金内訳照会',
    deposit_look: '入金照会',
    withdraw_list_look: '出金内訳照会',
    withdraw_look: '出金照会',
    account_modify: '口座の変更',
    deposit_apply: '入金申請',
    withdraw_apply: '出金申請',
    deposit_request_amount: '入金金額',
    withdraw_request_amount: '出金金額',
    withdraw_account_info: '出金口座情報',
    holder_name: '預金主',
    bank_name: '銀行名',
    withdraw_bank_address: '口座番号',
    withdraw_address: '資産アドレス',
    qr_address: '口座住所',
    create_qr_address: '口座アドレス開設',
    account_enroll: '口座登録',
    account_seq: '口座固有番号',
    account_title: '口座名',
    account_msg: '変更口座名を入力してください。',
    regdate: '開設',
    before_regdate: '(開設前)',
    holding_balance: '停止金額',
    select_asset: '選択資産',
    create: '開設',
    deposit_list: '入金内訳',
    no_deposit_list: '入金の申請内容がありません。',
    deposit_apply_detail: '入金の申請内訳の詳細',
    asset_title: '資産名',
    request_amount: '要求金額',
    withdraw_list: '出金内訳',
    no_withdraw_list: '出金の申請内容がありません。',
    withdraw_apply_detail: '出金の申請内容の詳細',
    withdraw_fee_total_amount: '総チュルグムエク（手数料含む）',
    net_amount: '最終的な金額',
    fee_type: '手数料の種類',
    create_account_address: '口座アドレス開設',
    deposit_msg: '外部財布から私の{0}の財布に{0}を堆積します。',
    deposit_msg_1:
      'ブロックチェーンで350回の承認（コンフォーム）を受けた後、{0}取引財布に反映されます。',
    deposit_step_1: 'STEP 1. {0}メモIDを先に確認してください。',
    deposit_step_1_1: '私{0}メモID',
    deposit_step_1_2:
      '{0}入金時、お客様の固有のメモIDを必ず表記してください。メモIDなしで送金された{0}は失われます。',
    deposit_step_1_3: '確認しました。私{0}財布アドレスを表示します。',
    deposit_step_1_btn: 'メモIDのコピー',
    deposit_step_2: 'STEP 2.私の財布アドレスをご確認ください。',
    deposit_step_2_1: 'QRコード',
    deposit_step_2_2: 'ウォレットアドレス',
    deposit_step_2_3:
      '最低入金額は<span style = "color：＃4a90e2"> {0} {1} </ span>です。',
    deposit_step_2_btn: '財布アドレスをコピー',
    deposit_msg_2: 'ご確認ください',
    deposit_msg_2_1: '上記アドレスは、入金専用アドレスです。',
    deposit_msg_2_2:
      'コンフォーム完了に要する合計時間は、ブロックチェーンネットワークの混雑度に応じて影響を受けることができ、パスワード貨幣星ブロックチェーン取り込みは<span style = "color：#4a90e2; cursor：pointer;">ここ</span>で確認することができます。',
    no_account_list: '口座のリストがありません。',
    no_favorite_account_list: 'お気に入り口座のリストがありません。',
    enter_wallet_adress: 'ウォレットアドレス入力',
  },
  my_page: {
    my_profile: '私の情報',
    user_name: 'ユーザ名',
    email_address: '電子メール',
    register_regdate: '登録日',
    last_login: '最近のログイン',
    auth_complete: '認証完了',
    not_auth: '米認証',
    expdate: '有効期限',
    act_auth: '認証する',
    realname_auth: '本人認証',
    email_auth: '電子メール認証',
    otp_auth: 'OTP認証',
    enroll: '登録する',
    security: 'セキュリティレベル',
    show_security: 'セキュリティレベル',
    auth_withdraw_address: '出金アドレス認証',
    apply_list: '申し込み内訳',
    password_modify: 'パスワードの変更',
    email_modify: '電子メールの変更',
    account_block: 'アカウント脱退',
    placeholder_old_password: '既存のパスワードを入力してください',
    placeholder_new_password: '新しいパスワードを入力してください',
    placeholder_confirm: 'もう一度入力してください',
    placeholder_password: 'パスワードを入力してください',
    placeholder_email: '新しい電子メールを入力してください',
    mail_cert_list: 'メールアプリケーションの履歴',
    no_mail_list: 'メールの申請内容がありません。',
  },
  kyc: {
    str_birth: '生年月日',
    enter_adress: '資産住所を入力してください。',
    register_account: '口座を登録する',
    kyc_enroll: 'KYC認証申請',
    auth: '認証',
    auth_code_send: '認証コード発送',
    auth_code: '認証コード',
    msg_auth_code: '認証コードを5分以内に入力してください。',
    type_title: 'ユヒョンミョン',
    withdraw_auth: 'ウォレットアドレス認証',
    select_asset: '選択資産',
    select_bank: '銀行の選択',
    holder_name: '預金主',
    birth: '生年月日6桁',
    address: '資産アドレス',
    withdraw_list: '出金口座の申請内容',
    bank_name: '銀行名',
    withdraw_info: '出金口座情報',
    withdraw_complete: 'すでに認証が完了した資産です。',
    regdate: '登録日',
    delete_withdraw_address: '出金アドレスの変更',
    delete_success_address: '出金アドレスが変更されました。',
    kyc_cert_list: 'KYCの申請内容',
    no_kyc_list: 'KYCの申請内容がありません。',
    no_kyc_withdraw_address_list: '出金口座の申請内容がありません。',
  },
  otp: {
    enter_verification_number: 'OTP認証番号を入力してください',
    otp_auth: 'OTP認証',
    authenticode: 'OTPキー',
    otp_deactivate: 'OTPを無効に',
    msg_authenticator_installation:
      'Google Authenticator」アプリをスマートフォンやデスクトップに設置してください',
    android: 'アンドロイド ',
    or: 'または ',
    iphone_series: 'iPhone、iPad、そしてiPod',
    windows_phone: ' Windows Phone',
    and: ', そして',
    msg_microsoft_other_systems: 'Microsoft Windows desktopを含む他のシステム',
    msg_key: 'このキーを ',
    msg_use_loss_change:
      ' 紙に書いてください。端末を紛失してしまったり、OTPを変更するときに使用されます。',
    msg_brcode_touch:
      'Google Authenticator」アプリを起動し、画面の下の<b> Scan QR barcode </ b>をタップしてください。',
    msg_input_authenticode:
      '端末の画面に表示された認証コードを下の「認証コード」の欄に入力してください。',
    otp_key: 'OTPキー',
    otp_activate: 'OTPを有効に',
    otp_copy: 'OTPキーがコピーされました。',
    otp_safe_keeping: 'OTPキーを紙に書いた後、安全な場所に保管しましたか?',
    yes: 'はい',
    otp_register: '登録',
    otp_register_success: 'OTP登録が正常に完了しました。',
    otp_delete_success: 'OTP抹消登録が正常に完了しました。',
    msg_click_key_copy: 'クリックすると、キーがコピーされます。',
    otp_login: 'OTPログイン',
  },
  security: {
    show_security: 'セキュリティ評価を表示',
    grade: '評価',
    condition: '条件',
    restriction: '制限',
    no_grade: '無段階',
    no: 'なし',
    security_title: 'セキュリティ等級別の条件別の制限事項',
  },
  input: {
    id: '入力されたID',
    password: '入力Aのパスワード（特殊文字8-32桁）',
    repeat_password: 'パスワードを認証する',
    user_name: '入力ユーザー名',
    email_address: '入力E-mailアドレス',
  },
  oauth: {
    contact_msg:
      'アプリケーション{0}で、以下の情報にアクセスしようとしています。',
    agree_msg: '{0}で{1}さんの個人情報にアクセスすることに同意しますか？',
    agree_info:
      '提供される情報は、利用者の識別、統計、アカウント連動やCSなどのためにサービス利用期間中に活用/保管されます。基本的な情報と必要な提供の項目は、ONEWORLDPAYサービスを利用するために、必ず提供されるべき情報です。',
    agree_request: '提供項目',
    agree_msg2:
      '同意後には、そのサービスの利用規約および個人情報の処理方針に基づいて情報が管理されます。',
    agree: '同意する',
  },
  pay_head_foot: {
    account_management: '口座管理',
    settlement_account_list: '精算口座管理',
    account_summary_views: '要約口座照会',
    fund: ' 資金',
    history: '支払い履歴',
    help: 'ヘルプ',
    qa: 'お問い合わせ',
    fee: '手数料',
    secure: 'セキュリティ',
    go_shop: 'ショッピング',
    my_info: '私のプロフィール',
    my_page: 'アカウントの設定',
    out: 'ログアウト',
    in: 'ログイン',
    about: '会社紹介',
    blog: 'ブログ',
    employ: '採用情報',
    site_map: 'サイトマップ',
    developer: '開発者',
    partner: 'パートナー',
    privacy_state: 'プライバシーポリシー',
    usage: '利用規約',
    feed_back: 'フィードバック',
    warn_to_consumer:
      '消費者に通知：ONEWORLDPAY前払い手段の所有者であるⓒONEWORLDPAY All rights reservedは、オーストラリア金融監督当局の承認を必要としません。利用規約を注意深くお読みください。',
  },
  continue: '続き',
  pay_home: {
    cocobank_title: 'COCOバンク',
    platform: 'プラットフォーム',
    platform_rental: 'プラットフォーム賃貸する',
    cocopay_is: 'ONEWORLDPAYは、ビジネスの成長を',
    help: '支援します。',
    home_banner_1: '全世界の潜在的な顧客基盤を広げ、請求管理を容易にし、',
    home_banner_2:
      'ビジネス販売保護*と年中無休詐欺防止監視を介して、安心してお買い物できるようにします。',
    home_banner_3: 'より簡単に成功することができます。',
    home_banner_warn:
      '*販売保護規約が適用されます。利用資格の詳細については、ユーザーの契約を参照してください。',
    home_banner_join: '今すぐ無料で登録してください。',
    home_sec1_openShop: 'ONEWORLDPAYで店を開設することができます。',
    home_sec1_btn: '取引する',
    home_sec2_h2: '希望の方法でのお支払い得る。',
    home_sec2_text1:
      'ONEWORLDPAYは、オンラインやモバイル、さらには電子メールでも決済することができます。',
    home_sec2_text2:
      'どこで誰に販売ハシドゥンONEWORLDPAYがより簡単で安全な支払いを支援します。',
    home_sec2_online_pay: 'オンライン決済',
    home_sec2_online_text:
      '簡単に設定可能なONEWORLDPAYの支払いボタンは決済代金と定期決済、寄付などを受ける時も非常に便利です。 ONEWORLDPAY Checkoutを利用すると、顧客がより簡単かつ迅速に決済することができます。',
    home_sec2_online_more: 'オンライン決済詳しくはこちら',
    home_sec2_voice_invoice: 'メールの請求書',
    home_sec2_voice_text:
      '専門的な無料の請求書に要求する簡単なメール決済。海外のお客様はもちろん、ONEWORLDPAYアカウントがないお客様にも使用することができます。',
    home_sec2_voice_more: 'メールの請求書についてさらに詳しく',
    home_sec2_exchange_pay: '取引所で決済する',
    home_sec2_exchange_text:
      '取引所で統合財布サービスを利用して、パートナーのいくつかの取引所でもコインを充電し、購入の販売を利用することができます。',
    home_sec2_exchange_more: '取引所の充電さらに詳しく',
    home_sec2_mobile_pay: 'モバイル決済受信',
    home_sec2_mobile_text:
      'ソリューションは、モバイルに自動的に最適化されます。世界中どこでも、モバイルウェブサイトやAndroidおよびiOSアプリを介して、より簡単に決済受けてください。',
    home_sec2_mobile_more: 'モバイル決済詳しくはこちら',
    home_sec3_h2:
      'ONEWORLDPAYフリーランスのパートナーと一緒に、より多くの仕事を見つけてください。',
    home_sec3_global:
      'ONEWORLDPAYは、世界最高のフリーランスのサイトと一緒に、より多くのグローバルなチャンスを接続します。',
    home_sec3_btn: 'フリーランスのためのONEWORLDPAY確認する',
    home_sec4_h2: '簡単に始めることができます。',
    home_sec4_banner1:
      'ONEWORLDPAYビジネスハブで開始に必要なすべてのことを知ってみましょう。',
    home_sec4_banner2: 'ビジネスアカウント登録してメールアドレスを確認する',
    home_sec4_banner3: '認証完了し、銀行口座を接続する',
    home_sec4_banner4: '決済ソリューションを選択する',
    home_sec5_h2: 'なぜ世界の多くの事業者がONEWORLDPAYを信頼でしょうか。',
    home_sec5_sub_text:
      '優れた選択であるからです。 ONEWORLDPAYは、売り手を世界200以上の市場の2億人以上のお客様に25個の通貨で連結しております。',
    home_sec5_h3: '安全です。',
    home_sec5_h3_sub1:
      '自動詐欺判別、24時間取引の監視販売と買い手保護プログラムで、ビジネスと顧客を保護します。',
    home_sec5_h3_more: 'オンライン決済詳しくはこちら',
    home_sec5_h31: '全世界が使用します。',
    home_sec5_h31_sub1:
      '世界中誰毎回情報を入力することなく、迅速に決済を行うことができます。 203個の市場で26通貨でのクレジットカード、デビットカード、またはONEWORLDPAYを介して決済することができます。',
    home_sec5_h31_more: 'メールの請求書についてさらに詳しく',
    home_sec5_h32: '高速です。',
    home_sec5_h32_sub1:
      '顧客が決済すると、ほとんどの場合、すぐに私のONEWORLDPAYアカウントに入金されます。銀行で引き出したりベンダーに代金を支払うか、またはONEWORLDPAY決済が可能なすべての場所で自由に使用してください。',
    home_sec5_h32_more: 'eBay販売詳細を見る',
    home_sec6_h2: '単純な手数料体系',
    home_sec6_sub:
      'ONEWORLDPAYは販売がされたときのみ手数料を請求します。 ONEWORLDPAY手数料は販売金額と現在の場所を基準に固定されています。',
    home_sec6_more: '手数料についてさらに詳しく',
    home_sec7_h2: '韓国セラーのためのコミュニティ、CBT LAB',
    home_sec7_text1:
      'クロスボーダー取引の研究所（CBT LAB）はONEWORLDPAYコリア（ONEWORLDPAY Korea）が海外の電子商取引活性化のために後援する販売のコミュニティです。',
    home_sec7_text2:
      'CBT LABは、最新の動向、ヒント、ベストプラクティスなどの情報共有を東海ビジネスが世界的に成長できるように支援しています。',
    home_sec7_more: 'CBT LAB活用方法を学ぶ',
    home_sec8_h2: 'ONEWORLDPAYを連動したパートナーに会ってみてください。',
    home_sec8_text1: 'オンラインビジネスのための専門家の助けが必要ですか？',
    home_sec8_text2:
      'Webホスティングソリューションは、ショッピングカート、EコマースソリューションなどONEWORLDPAYを事前連動したパートナーがお客様のビジネスを支援します。',
    home_sec8_text3:
      '私のビジネスに適したONEWORLDPAYのパートナーを今見つけてください。',
    home_sec8_more: 'より多くのパートナーを表示',
    home_sec9_h2:
      'グローバルセラーになってみてください。 ONEWORLDPAYが付属致します。',
    home_sec9_btn: '今すぐアカウントを登録する',
    home_learn_h2: 'さらに詳しく',
    home_learn_li1: 'ウェブ決済ソリューション',
    home_learn_li1_1: 'Website Payments Standard',
    home_learn_li1_2: 'ONEWORLDPAY Checkout',
    home_learn_li1_3: 'eBayで販売する',
    home_learn_li1_4: 'ソリューションの比較',
    home_learn_li2: 'その他のお支払い',
    home_learn_li2_1: 'ONEWORLDPAYメールの請求書',
    home_learn_li2_2: 'モバイルコマース',
    home_learn_li2_3: 'ビジネス用の自動支払い',
    home_learn_li2_4: 'B2BのためのONEWORLDPAY',
    home_learn_li2_5: 'フリーランスのためのONEWORLDPAY',
    home_learn_li3: 'ONEWORLDPAY設定と統合',
    home_learn_li3_1: 'ONEWORLDPAYビジネスハブ',
    home_learn_li3_2: 'ONEWORLDPAYコリア販売コミュニティ（CBT LAB）',
    home_learn_li3_3: 'サイトにONEWORLDPAY ONEWORLDPAY追加する',
    home_learn_li3_4: 'チェックアウトの設定、ベストガイド',
    home_learn_li3_5: '開発者',
    home_learn_li3_6: 'パートナー',
    home_learn_li3_7: 'ONEWORLDPAY使い方',
    home_learn_li4: 'マイアカウントの管理',
    home_learn_li4_1: 'ONEWORLDPAYビジネスアプリ',
    home_learn_li4_2: 'ビジネスアカウントの設定',
    home_learn_li4_3: '販売保護プログラム',
    home_learn_li4_4: '顧客からの苦情を管理する',
    home_learn_li4_5: '支払い拒否（Chargeback）を理解する',
    home_learn_li4_6: 'アカウントの制限を理解する',
    home_learn_li4_7: '詐欺防止のヒント',
    home_learn_li4_8: 'PCIコンプライアンス',
  },
  pay_nav: {
    view_your_account: '前口座照会',
    account_summary_views: '要約口座照会',
  },
  pay_login: {
    secure_sub_title: 'ログインとセキュリティ',
    secure_my_profile: '私のプロフィール',
    secure_update_complete: 'プロファイルと設定環境が更新されました。',
    secrue_suggest: 'いつでもお客様のご意見を言ってください。',
    search: '検索',
    my_info: '個人情報',
    update: 'アップデート',
    e_mail: 'メール',
    default: 'Basic information',
    call: '電話',
    phone: '（携帯電話）',
    pay_mobile: 'モバイル決済',
    trading: '送受信',
    password: 'パスワード',
    change: '変更',
    secure_qa: 'セキュリティの質問',
    staying: 'より速い購入のためにログイン状態を保持する',
    edit: '編集',
    browse_manage:
      'ログイン状態を維持するように選択された機器とブラウザを管理します。',
    account_type: 'アカウントの種類',
    account_delete: 'アカウント解約',
    business: 'ビジネス',
    edit_email: 'メールアドレスの編集',
    change_email: 'メールアドレスの変更',
    update_email: 'メールを追加',
    eamil_url: 'メールアドレス',
    update_email_url: 'メールアドレスの追加',
    error_email:
      '申し訳ありません。デフォルトの電子メールは、編集することができません。',
    confirm_new_email: '新しいメールアドレスの確認',
    change_mail: 'メール変更',
    confirm: '確認',
    changing: '変更',
    deleting: '削除',
    reaming:
      '現在の電子メールアドレスが2つのアカウントにリンクされています。 5つの電子メールを追加することができます。',
    qa_1: '初めて通った学校の名前は何ですか？',
    qa_2: '最初のペットの名前は何ですか？',
    edit_phone: '既存の電話番号を編集',
    korea: '大韓民国',
    explanation:
      '番号を追加することにより、本人はこの番号を追加する権限があり、プライバシーに記載された理由に基づいて自動的にダイヤルと事前録音電話や文字の受信に同意することを確認します。標準料金が適用されることがあります。',
    edit_phone_num: '電話番号の変更',
    edit_password: 'パスワードの変更',
    confirm_password: '現在のパスワードを確認',
    new_passod: '新しいパスワード',
    confirm_password_new: '新しいパスワードの確認',
    secure_question: 'セキュリティの質問',
    secure_pick: '質問を選択',
    secure_answer: '回答',
    edit_browse:
      'ONEWORLDPAY One Touchを利用すれば、毎回ログインすることなく、迅速に決済を完了することができます。',
    already_log: 'この機器にログインされた状態です。',
    off_all: 'すべての機器でONEWORLDPAY One Touchオフ',
    support:
      'PayPalは、お客様の100％満足のために最善を尽くしています。アカウントに問題がある場合',
    support_center: 'サポートセンター',
    support_text1: 'に確認したり、',
    support_text2: 'にお問い合わせください。',
    support_warn:
      'アカウントを解約すると元に戻すことはできませんアカウントの記録と信頼性の数値も消えてしまいます。',
  },
  help: {
    support_center: 'サポートセンター',
    resolution_center: '紛争解決センター',
    qa_search: 'よくある質問検索',
    common_qa: '一般質問',
    common_qa_1:
      '`金額受ける`リンクを介して注文状況を更新した後、エラーメッセージが表示されるのはなぜですか？',
    common_qa_2:
      '韓国ONEWORLDPAYアカウントから資金を引き出すにはどうすればよいですか？',
    common_qa_3:
      '私ONEWORLDPAYアカウントにデビットカードやクレジットカードを追加するには、どうすればいいですか？',
    common_qa_4:
      'マイONEWORLDPAYアカウントのパスワードを忘れました。パスワードをリセットするには、どうすればいいですか？',
    common_qa_5:
      'すでに送信ONEWORLDPAY決済代金をキャンセルすることができますか？',
    common_qa_6: 'ONEWORLDPAYを通じて支払いを受けるにはどうしますか？',
    common_qa_7:
      'ONEWORLDPAYを通じて決済代金を送信するにはどうすればいいですか？',
    common_qa_8:
      'ONEWORLDPAYアカウントに銀行口座を追加するには、どうすればいいですか？',
    common_qa_9:
      '私ONEWORLDPAYアカウントに接続された銀行口座を確認するには、どうすればいいですか？',
    common_qa_10:
      'ONEWORLDPAYアカウントの制限を解除するには、どうすればいいですか？',
    technical_support: '技術関連の問題と更新を購読してください。',
    condition_cocopay: 'ONEWORLDPAY状態を表示する',
    muliple_help: '助けを受けるより、さまざまな方法',
    trading_help: '取引の問題などを解決する',
    tex_center: '税金センター',
    tex_help: '税務フォーム、およびその他のリソースの検索',
    need_help: 'お問い合わせ',
    help_center: 'サポートセンターへのお問い合わせ',
    help_to_center: 'サポートセンターへのお問い合わせ',
    prepare: '準備中です。',
    fast_help:
      'ONEWORLDPAYでより迅速に支援することができるように、お客様の問題を教えてください。',
    my_search: '私の問題を検索',
    common_problem: '一般的な問題',
    login_problem: 'ログインの問題',
    unkown_charge: '不正アクセスまたは知ら請求申告',
    send_money: '金額を送る',
    get_fund: '資金取得',
    withdraw_money: '金額引き出し',
    pay_cancel: '決済または注文のキャンセル',
    pay_hold: '決済保留または待機中',
    refund: '払い戻し',
    pre_pament: '事前承認支払い',
    negative_balance: 'マイナス残高',
    account_qa_1:
      'マイONEWORLDPAYアカウントから引き落とさ状態が「完了」と表示され資金が銀行口座に入っていないのはなぜですか？',
    account_qa_2:
      '私ONEWORLDPAY引き出しがまだ「待機中」の状態であるのはなぜですか？',
    account_qa_3: '私の引き出しが保留された理由は何ですか？',
    item_title: 'パスワードとアカウントへのアクセス',
    item_title_2: 'アカウントプロファイルと設定',
  },
  business: {
    no_trade: '両替可能なマーケットがありません。',
    view_your_account: '前口座照会',
    available: '使用可能',
    calculate_late: '最近両替率をベースにした推定量。',
    payment_transfe: '決済代金振り込み',
    exchange: '両替',
    currency_update: '通貨を追加',
    update_btn: 'プラスボタン',
    currency_cal: '通貨の計算機',
    pay_default: '決済の設定',
    payment_send: '決済代金送信または要求',
    account_list: '口座リスト',
    no_alias: 'エイリアスなし',
    new_bank: '新しい銀行接続',
    card: 'カード',
    new_card: '新しいカードの接続',
    credit: 'クレジット',
    preference_payment: '好ましいオンライン決済手段を選択してください。',
    payment_tip:
      'オンラインでショッピングしたり、商品やサービスの決済代金を送信するときに、この手段を使用しています。決済時はいつでも、他の決済手段を選択することもできます。',
    payment_more: '決済の設定についてをご覧ください。',
    paymnet_changes: 'ONEWORLDPAY残高',
    debit_card: 'デビットカード',
    currency_tip:
      '通貨を追加すると、その通貨で受け取る今後すべての支払いは、残高に入金されます。決済代金を送信したり、要求したとき、デフォルト通貨が使用されます。',
    currency_1: 'オーストラリアドル',
    currency_2: 'スイス・フラン',
    currency_3: 'チェココルナ',
    currency_4: 'デンマーククローネ',
    currency_5: 'ユーロ',
    currency_6: '英国ポンド',
    currency_7: '香港ドル',
    currency_8: 'フォリント',
    currency_9: 'イスラエル新シュケル',
    currency_10: 'メキシコペソ',
    currency_11: 'ノルウェークローネ',
    currency_12: 'ニュージーランドドル',
    currency_13: 'フィリピンペソ',
    currency_14: 'ポーランドズロチ',
    currency_15: 'ロシアのルーブル',
    currency_16: 'スウェーデンクローナ',
    currency_17: 'シンガポールドル',
    currency_18: 'バート',
    currency_19: '新台湾ドル',
    withdraw_account: '出金口座',
    exchanged: '両替後の通貨',
    exchange_rate: '為替レート',
    exchange_tip:
      'この為替レートは、現在の為替レートをベースにした推定金額であり、ONEWORLDPAYの両替手数料が含まれます。',
    currency_default: '日本円を基本通貨として設定します。',
    currency_default_notice:
      '決済代金を送信したり、要求したとき、デフォルト通貨が使用されます。',
    currency_default_notice2:
      'この通貨を閉じる他のお支払いをこの通貨でない限り残高に表示されません。',
    currency_default2: 'JPYを基に設定',
    currency_quit_jp_btn: '日本のドルを閉じる',
    currency_quit_btn: '通貨閉じる',
    bank_account: '口座',
    bank_account_create_day: '開設',
    bank_account_change: '残高',
    bank_account_check: '銀行確認',
    bank_account_remove: '銀行削除',
    bank_continue: '続きしますか？',
    bank_tip: 'この銀行を利用した大気中の取引は、削除された後も処理されます。',
    bank_this_delete: 'この銀行削除',
    card_tip:
      'ONEWORLDPAYアカウントを使うか引き出し限度なしに使用したいですか？',
    card_confirm: 'カードを確認してください。',
    card_type: 'タイプ',
    expiry_date: '有効期限',
    card_adress: '請求先住所',
    card_update: 'カードの更新',
    card_delete: 'カードの削除',
    card_this_delete: 'このカードの削除',
    card_tip2:
      '現在好ましい決済手段です。完了時に、他の好ましい決済手段を設定することができます。このundefinedを利用した大気中の取引は、削除された後も処理されます。',
    secure_code: 'セキュリティコード',
  },
  shop: {
    shop_list: '店リスト',
    shop_create: '店生成',
    shop_cre_date: '登録日',
    shop_title: '店名',
    shop_id: '店ID',
    shop_state: '状態',
    shop_work: '作業',
    shop_detail: '詳細',
    shop_retouch: '修正',
    shop_settlement: '精算口座リスト',
    shop_history: '取引の詳細',
    no_shop_history: '取引履歴はありません。',
    no_shop_list: '店のリストがありません',
  },
  merchant: {
    create: '店の登録',
    update: '登録する',
    retouch: '店の修正',
  },
  pay_legal: {
    service_usage: 'ONEWORLDPAYサービス利用規約',
    detail_usage:
      'これらの利用規約は、アジア太平洋地域、一部のヨーロッパ、ラテンアメリカ諸国、中東、アフリカのユーザーに適用されます。他の国や地域の利用規約を表示するには、以下のリストから選択します。',
    nation: '国を選択',
    every_consumer: 'すべてのユーザー',
    service_agree: 'ONEWORLDPAYサービスのためのユーザーの契約',
    privacy_state: 'プライバシーポリシー',
    purpose_policy: 'ONEWORLDPAY利用目的の制限のポリシー',
    payment_agreement: 'ONEWORLDPAY代替決済手段の契約',
    sell_buy: '売り手とのビジネス',
    shop_policy: 'ONEWORLDPAYサポートモールポリシー',
    contract_profit: '営利法人の契約',
    billing_agreement: '請求契約',
    direct_debit_agreement: 'ONEWORLDPAY資金を受信し、口座振替契約',
    additional_info: '追加情報',
    infringement: '侵害ソミョンソポリシー',
    policy_update: 'ポリシーの更新',
    warn1:
      '消費者に通知：ONEWORLDPAY決済サービスは、オーストラリアの法律に基づいて前払い手段（Stored Value Facility）とみなされます。',
    warn2:
      'ONEWORLDPAY前払い手段の所有者であるⓒONEWORLDPAY All rights reservedは、オーストラリア金融監督当局の承認を必要としません。消費者（ユーザー）は、これらの利用規約を注意深くお読みください。',
    warn3:
      'これらの利用規約と告知は、特定のONEWORLDPAYサービスに関連する利用規約を提供しています。',
  },
  pay_privacy: {
    effective_day: '効力発生日：2019年3月28日',
    summary: '概要',
    personal_data: 'ONEWORLDPAYで収集する個人データ',
    personal_date_cause: 'ONEWORLDPAYで個人データを保持する理由',
    summary_1: 'は、ユーザーが当社',
    summary_2: 'サイト',
    summary_3: 'を訪問したり、',
    summary_4: 'サービス',
    summary_5: '利用時にユーザーの',
    summary_6: '個人データ',
    summary_7:
      'をどのように収集し、保管し、管理し、共有し、送信していることについて説明するために、本プライバシーポリシーを設けました。このプライバシーポリシーは、当社のサイトを訪問したり、サービスを利用する際、ユーザーの個人データに適用され、他のONEWORLDPAY',
    summary_8: 'ユーザー',
    summary_9:
      'のウェブサイトやサービスを含むONEWORLDPAYが所有または調整していないオンラインのウェブサイトやサービスには適用されません。',
    summary2_1:
      'ONEWORLDPAYは、ユーザーが当社のサイトを訪問したり、サービスを利用する際は、次のタイプの個人情報を収集することができます。',
    summary2_2: '登録と情報の使用',
    summary2_3:
      'ONEWORLDPAYのサービスを利用するためにアカウントを作成し登録すると、必要な情報を満たして、ユーザーが要求するサービスを提供するために、個人データを収集します。',
    summary2_4:
      '選択したサービスに応じて、ユーザーの名前、メールアドレス、電話番号、電子メールアドレス、アカウントを作成するために必要な識別情報などを提供してもらう要求することができます。',
    summary2_5:
      'ご利用のサービスに応じて追加の個人データを提供してもらう要求することができます。',
    summary3_1: '取引や経験について',
    summary3_2:
      'ONEWORLDPAYのサービスを利用したり、サイトに接続する場合は、例えば、販売から購入したり、金額を受領するか、請求を処理したり、友人や家族に金額をお送りいただく場合、ONEWORLDPAYで取引情報だけでなく、その他の取引関連情報を収集します。その他の取引関連情報は、送信したり、要求された量は、製品またはサービスに決済した金額、取引を完了するために使用されたすべての決済手段に関する情報を含む販売情報、機器情報、技術の使用データ、位置情報などが含まれます。',
    summary4_1: '参加者情報',
    summary4_2:
      'ONEWORLDPAYサービスを利用したり、サイトにアクセスすると、ユーザーが取引に関連するその他の参加者に提供する個人データを収集します。',
    summary4_3: '金額の送信または要求する',
    summary4_4:
      'ONEWORLDPAYサービスを通じて金額を送信したり、要求した場合、名前、メールアドレス、電話番号、ユーザからの金額を受けたり、ユーザーに金額を送る参加者の金融口座情報などの個人データを収集します。',
    summary4_5:
      '参加者に関連して、要求する個人データの範囲は、金額を送信したり、要求するために利用するサービスに応じて異なります。',
    summary5_1: '他の代わりの請求書を決済するか、他の人に告知書決済依頼する',
    summary5_2:
      '他の代わりの請求書を決済するか、他のユーザーに自分の代わりに請求書を決済してもらう要求するためONEWORLDPAYサービスを使用する場合は、ユーザーから名前、住所、電話番号、電子メールアドレス、ユーザーが代わりに請求書を決済するか、他の人この代わりに、決済するようにしようとする口座番号を含むアカウントの所有者に関連する個人データを収集します。',
    summary6_1: 'アカウントに金額を追加する',
    summary6_1_1: 'ユーザーのアカウント',
    summary6_2:
      'ユーザーのアカウントまたはユーザーが所有することができる他のアカウントに資金を追加するために、または他のユーザーにこれらのアカウントに金額を追加してほしいと要請するためにONEWORLDPAYサービスを使用する場合は、要求を円滑に処理するために、ユーザーから相手の情報を収集したり、相手からユーザーに関する情報を収集することができます。',
    summary6_3:
      '例えば、携帯電話を充電したり、携帯電話の口座に金額を追加してほしいと要請するためにONEWORLDPAYサービスを使用する場合は、他の参加者からの個人データ、およびモバイル口座番号を含むその他の情報を収集することができます。',
    summary7_1: '友達と連絡先の人と関連した情報',
    summary7_2:
      'ユーザーが連絡先リストをアカウントに接続すると、お友達と連絡先の人との取引時ONEWORLDPAYでの助けとなる、より容易にします。ユーザーが機器やソーシャルメディアのプラットフォーム間の接続を設定したり、ONEWORLDPAYアカウントを機器やソーシャルメディアプラットフォームと接続すると、ONEWORLDPAYから連絡先リストの情報（名前、住所、電子メールアドレスなど）を収集し、利用して、より良いONEWORLDPAYサービスを利用できるように環境を改善します。',
    summary8_1:
      'ユーザーが追加のサービスまたは特定のオンラインサービスを利用するためにONEWORLDPAYに提供することに選択した情報',
    summary8_2:
      '選択的なサイトの機能を要求または参加したり改良されたサービスまたはその他の選択機能を要求する場合には、ONEWORLDPAYでユーザーの追加情報を収集することができます。',
    summary8_3:
      'このサービスで収集された情報の使用方法が、本プライバシーポリシーで明らかにした内容と異なる場合は、情報を収集する際告知します。',
    summary9_1:
      '「ONEWORLDPAY非会員決済」サービスを利用する場合は、ユーザーに関する情報',
    summary9_2:
      '一部の限られたサービスの場合は、ログインするか、非会員決済でアカウントの設定をしなければなら利用することができます。 ONEWORLDPAYは、ユーザーがトランザクションを完了するために必要な個人データは、すべての決済手段関連機器情報、技術の使用データ、位置情報を収集します。ユーザーがアカウントの所有者であり、非会員取引の決済を選択した場合、取引関連情報を収集して、ユーザーのアカウントと関連付けることができます。',
    summary9_3:
      'ユーザーがアカウントの所有者ではないながらONEWORLDPAY非会員取引の決済を選択した場合、ユーザーが提供したすべての情報を収集し、保存して、その情報をこのプライバシーポリシーに基づいて使用して共有します。',
    summary10_1: '他社で取得ユーザーに関する情報',
    summary10_2:
      '売り手、データプロバイダ、クレジット調査機関のような第三者からの法律が許可する範囲内で情報を得ることができます。',
  },
  partner: {
    be_partner: 'ONEWORLDPAYのパートナーになってみてください。',
    banner_text:
      'ショッピングモールのプラットフォームプロバイダ、マーケットプレイス、決済サービスを必要とする事業者を支援する決済代行業者がONEWORLDPAYのパートナーになることがあります。',
    banner_btn: 'パートナー担当者に連絡する',
    benefit: 'ONEWORLDPAYパートナーが受けることができる利点',
    benefit_1: 'ソリューションを構築するための統合と技術サポート',
    benefit_2:
      'ONEWORLDPAY統合の助けとなるためのサポートにいつでもお問い合わせください。 ONEWORLDPAY開発者ポータルもリソースとして活用することができます。',
    benefit_3: 'マーケティングの機会を通じたビジネスの成長',
    benefit_4:
      'ONEWORLDPAYが提供する様々なマーケティングの機会を活用して潜在的な顧客を引き付けることができます。',
    traction: '全世界の決済を牽引しています。',
    traction1:
      'ONEWORLDPAYパートナーはONEWORLDPAYを信頼する販売者の円滑な決済のための革新的なプラットフォームをサポートしています。',
    traction_btn: 'より多くのパートナーを表示',
    program: 'ONEWORLDPAYパートナープログラムに参加は無料です。',
    program_1:
      'オンラインフォームに記入していただければONEWORLDPAYで連絡をいたします。',
    program_2: '運営しているビジネスとソリューションについて説明してください。',
    program_3: '必要な事項を議論するためにONEWORLDPAYで連絡致します。',
    program_4:
      'ONEWORLDPAYと統合して、彼らはONEWORLDPAY支払いを受けることができるよう支援します。',
    program_btn: 'パートナー担当者に連絡する',
    common_qa: 'よくある質問',
    common_qa1: 'いくつかのメーカーがONEWORLDPAYパートナーにありますか？',
    common_qa1_text:
      'ONEWORLDPAYパートナーは、自社の顧客にONEWORLDPAYソリューションを提供するB2B（企業対企業）企業です。 ONEWORLDPAYはショッピングカート、ウェブホスティング会社は、Web開発者、物流業者、デジタルマーケティング代理店、決済ゲートウェイなどの組織と協力しています。',
    common_qa2: 'ONEWORLDPAYパートナーサポート資格は何ですか？',
    common_qa2_text: 'パートナーの担当者にお問い合わせ',
    common_qa2_text_2:
      'とパートナーの資格要件について相談受けることができます。',
    common_qa3: 'ONEWORLDPAYで統合サポートサービスを提供していますか？',
    common_qa3_text:
      'ONEWORLDPAYパートナープログラムに登録して、登録を承認受ける有用な統合関連文書および開発者フォーラムにアクセスすることができます。また、証明書の作成のための統合のコンサルタントの支援も受けることができます。',
    common_qa4:
      '韓国外でもビジネスを運営しているが、パートナープログラムに国別に登録しますか？',
    common_qa4_text:
      'ビジネスを運営している国によって異なります。 ONEWORLDPAYは地域のニーズに特化したパートナーの担当者を複数の国に配置しています。',
    common_qa4_more: 'パートナープログラムの提供国を見る',
  },
  pay_main: {
    total_product: '商品合計',
    total_sum: '量',
    pay_this_account: 'この口座を決済手段に設定します。',
    bill_show: 'この取引は、明細書には、次のように表示されます。',
    banner_text: 'ONEWORLDPAYは、より安全で',
    banner_text2: 'クイック決済方法です。',
    banner_text3: 'どこで買い物をしても、金融情報を安全に守ります。',
    footer_1: '規約',
    footer_2: 'ユーザー契約',
    footer_3: 'プライバシーポリシー',
    footer_4: 'フィードバック',
    footer_5:
      '消費者に通知：ココバンク前払い手段の所有者であるⓒONEWORLDPAY All rights reservedは、スウェーデン金融監督当局の承認を必要としません。',
    footer_6: '利用規約',
    footer_7: 'を注意深くお読みください。',
    footer_8: '決済',
    wallet: '電子財布管理',
    last_name: '性',
    card_number: 'カード番号',
    three_number: '3桁の',
    name: '名前',
    pay_cocopay: 'ONEWORLDPAYで支払い',
    free_shipping:
      'ONEWORLDPAYアカウントがあれば、無料返品送料、購入保護などを受けることができます。',
    email_phone: '電子メールまたは携帯電話番号',
    login_error: 'ログインに問題がありますか？',
    pay_card: 'カードで決済',
    cancel_back: 'キャンセルして前のページに戻る',
  },
  site_map: {
    site_map_tip: 'ONEWORLDPAYアカウントを見回すと、役立つリンクです。',
    map_fund: '資金',
    map_fund_1: '金額振替',
    map_fund_2: '私の使用機能のバランスとは？',
    map_fund_3: '金額の送信または要求',
    map_fund_4: '通話管理',
    map_fund_5: '私ONEWORLDPAYデビットカード割引',
    map_fund_6: 'ONEWORLDPAYデビットカード取得',
    map_fund_7: 'ONEWORLDPAY Credit決済スケジュールの設定',
    map_deal: '取引',
    map_deal_1: 'すべての取引活動の履歴を表示',
    map_deal_2: '活動履歴の表示（残高と手数料を含む）',
    map_deal_3: '取引グラフとチャートを表示',
    map_deal_4: '取引ダウンロード',
    map_deal_5: 'クレームやチャージバックに応答',
    map_deal_6: 'IPN（即時決済通知）の履歴',
    map_profile: '私のプロフィールと設定',
    map_profile_1: 'ビジネス情報ミョンギョン',
    map_profile_2: '電子メール、住所、電話またはパスワードの更新',
    map_profile_3: '銀行口座やカードの更新',
    map_profile_4: '通知の更新',
    map_profile_5: 'アカウントの制限を表示',
    map_profile_6: 'ユーザーの管理',
    map_profile_7: '配送設定の更新',
    map_support: 'サポート',
    map_support_1: '紛争解決センターに移動',
    map_support_2: 'サポートセンターに移動',
    map_support_3: 'お問い合わせ',
    map_support_4: 'ONEWORLDPAY販売手数料について',
    map_report: 'レポート',
    map_report_1: 'レポートの設定、管理、またはダウンロード',
    map_manage: 'ツール',
    map_manage_1: '私のツールを表示',
    map_manage_2: 'ONEWORLDPAYボタン管理',
    map_manage_3: '定期支払いの管理',
    map_consum: 'お客様',
    map_consum_1: '顧客リストを表示',
  },
  fee: {
    fee_tip: 'シンプルな料金体系',
    fee_banner_1:
      '一般的に、購入は無料で両替手数料が適用される場合があります。',
    fee_banner_2:
      'ONEWORLDPAYを利用して販売する月の手数料やキャンセル料が付きません。各販売後の手数料のみ支給します。',
    fee_h2: '一般的に、購入は無料です。',
    fee_text1: '決済処理のための手数料は、売り手が支払います。',
    fee_text2: 'ただし、両替手数料が適用される場合があります。',
    fee_more: '販売手数料さらに詳しく',
    fee_text3:
      'ウェブサイトからの請求書やメール決済を利用して販売します。（海外決済標準料率を適用）',
    fee_text4: '受領した通貨に基づいた固定料金',
    fee_text5: '両替手数料が追加で適用されることができます。',
    fee_text6: 'たとえばUSDで受領された決済金額の固定料金は$ 0.30 USDです。',
  },
  dash: {
    more: 'もっと見る',
    withdraw_asset: '資金引き出し',
    currency: '通貨',
    quotes: '請求書や見積',
    last_6_months: '最近6ヶ月',
    make_invoice: '請求書の作成',
    manage_invoice: '請求書の管理',
    grown_up: '見積もりを送って、ビジネスを成長させるましょう。',
    un_paid_invocie: '未払いの請求書',
    make_quotes: '見積作成',
    quotes_1: '1件の未払いの請求書があります。',
    quotes_2: 'ONEWORLDPAY請求',
    quotes_alarm: '事前通知の送信',
    quotes_detail: '詳細表示',
    quotes_who: '請求対象：チェ・ソヨン',
    latest_act: '最近の活動内容',
    act: '活動',
    received: '受信した決済代金',
    send: '送信決済代金',
    act_record: '活動内容（残高および手数料を含む）',
    pay_person: '請求者名',
    show_all: 'すべて表示',
    tell_us: '意見を教えてください。',
    feed_text:
      'しばらく時間を割いて、このページの再設計された情報を表示するにコメントを教えてください。ありがとうございます！',
    service: 'フィードバックを提供',
    feed_text_back:
      '意見をいただきありがとうございます！私たちのサイトがどのように役立つましたか？',
    feed_placeholder:
      '今日ONEWORLDPAYに来た理由を教えていただければ、より良い方法があります。電子メールまたはアカウント番号などの個人情報が含まれていません。',
    feed_p:
      'ONEWORLDPAY従業員とオフィスのお客様が見ることができるようにあなたの意見が内部的に発行されることがありますので、個人情報を残さないでください。顧客サービスの問題は、こちらをクリックしてください。 ONEWORLDPAYの',
    feed_protect: '個人情報保護方針',
    feed_law: '法的条件',
    feed_or: 'と',
    feed_need: 'を参照してください',
    trade_name: '取引人',
    trade_id: '取引ID',
    transaction_type: '取引タイプ',
    trade_amount: '決済金額',
    detail_show: '表示',
  },
  shop_detail: {
    detail_info: '店の詳細',
    api_signature: '店署名キー',
    msg_shop_create: '店が登録されました。',
    msg_shop_modify: '店が修正されました。',
  },
  merchant_account: {
    create_account: '精算口座作成',
    enroll_account: '精算口座登録',
    pls_select_account: '精算口座を選択してください',
  },
  transaction_detail: {
    select_pay_account: '支払い口座選択',
    transaction_title: '取引の詳細',
    order_id: '店舗注文番号',
    pay_account_title: '支払い口座名',
    pay_account_number: '支払い口座番号',
    pay_account_balance: '支払い口座残高',
  },
  guide: {
    title: 'C2C トレードガイド',
    watch_video: '映像表示',
  },
  account_transfer: {
    transfer: '口座振替',
    transfer_list: '振込内訳',
    msg_required_data: '値をすべて入力してください',
    msg_not_select_withdraw_account: '出金口座を選択してください',
    create_transfer_title: '口座振替',
    from_account_select: '出金口座を選択',
    available_transfer: '振り込み可能金額',
    to_account_input: '振替口座番号を入力',
    to_account_confirm: '振り込み口座確認',
    to_account_user_name: '振替口座の会員名',
    transfer_amount: '振込金額',
    delete_amount: '訂正',
    all_amount: '全額',
    description: '説明',
    transfer_btn: '振込',
    transfer_btn_2: '外部へ送金',
    transfer_info_check: '振り込み申請情報確認',
    transfer_info_check_2: '外部へ送金お申込み情報確認',
    from_account_number: '出金口座番号',
    from_asset_title: '出金口座の資産',
    to_account_number: '振替口座番号',
    success_transfer: '振り込み完了しました。',
    success_withdraw: '出金が正常に処理されました。',
    transfer_list_detail: '振り込み内訳詳細',
    search_transfer_asset: '資産別検索',
    search_transfer_account: '口座別検索',
    reset: '初期化',
    search: '検索',
    transfer_list_detail_tit: '変形履歴の詳細',
    no_transfer: '変形の履歴なし',
    msg_not_search_account: '存在しない口座番号または無効入力値です。',
    my_account_transfer: '本人口座振替',
    msg_pls_select_account: '資産を選択した後、口座を検索してください。',
    placeholder_amount: '振替金額を入力してください',
    not_search_user_name: 'ユーザ名を確認できません',
    msg_select_asset_search: '口座を選択してください。',
    success_fail: '外部送金が心配されました。',
    pls_search_asset: '資産を検索してください。',
    pls_search_account: '口座を検索してください。',
    pls_select_asset: '資産を選択してください。',
    select_account_first: '口座を先に選択してください。',
    select_market_first: '市場を先に選択してください',
    not_exist_account: '当該資産の口座が存在しません。',
    favorites: 'お気に入り',
    no_inquiry_history: '照会内容がありません。',
    from_user_name: '出金口座の会員名',
  },
  bank_service_center: {
    title: 'タイトル',
    date: '日',
    state: '状態',
    enter_search_word: '検索用語を入力してください',
    list: 'リスト',
  },
  service_center: {
    view_all: '一覧',
    contact_history: 'お問い合わせ内容',
    privacy_Statement: 'プライバシーポリシー',
    would_you_agree: '上記の内容に同意しますか？',
    mobile_number: '携帯電話番号',
    target_of_inquiry: 'お問い合わせタイトル',
    inquiry_contents: 'お問い合わせの内容',
    please_enter_your_inquiry: 'お問い合わせ内容を入力してください。',
    send: '送信',
    normal_inquiries_received:
      'お問い合わせいただいた内容が正常に受付完了しました。',
    inquiry_history: 'お問い合わせ内容に',
    pls_select_inquiry_type: 'お問い合わせの種類を選択してください',
    pls_login_to_use_inquiry:
      '1：1お問い合わせを利用するには、ログインしてください。',
    non_member_login: '非会員ログイン',
    contact_id: 'お問い合わせのID',
    view_inquiry: 'お問い合わせ表示',
    service_center: 'お客様センター',
    inquiry_details: 'お問い合わせ詳細',
    msg_enter_title: 'タイトルを入力してください。',
    msg_enter_your_content: '内容を入力してください。',
    msg_pls_login: 'ログインしてください。',
    go_back: '戻る',
    re_contact: '再問い合わせ',
    contents: '内容',
    msg_no_inquiry_history: 'お問い合わせ内容がありません。',
    msg_require_login_additional_authentication:
      'ログインまたは追加の認証が必要です。',
    when_you_member: '会員であるとき',
    msg_inquiry_history_can_view_after_login:
      '会員のお問い合わせ内訳はログイン後閲覧可能です。',
    non_member: '非会員であるとき',
    lookup_inquiry: 'お問い合わせ照会',
    msg_enter_inquiry_id: 'お問い合わせIDを入力してください。',
    msg_enter_password_when_registering_your_inquiry:
      'お問い合わせ登録時に設定したパスワードを入力してください。',
    frequently_asked_questions: 'よくある質問',
    msg_enter_your_password: 'パスワードを入力してください。',
  },
  modal: {
    not_seeing_day: '日中見ない',
  },
  login_guide_modal: {
    title: '案内事項',
    sub_title:
      '会員たちの円滑な取引所利用のために、ログインシステムが改編される予定です。',
    content:
      '【変更前】<br/>最初に登録時に作成IDログイン<br/><br/> [変更後] <br/>使用されている電話番号やメールアドレスログインに変更<br/> <br/>ログインシステムが改変されるまでログイン方法は、最初加入の際に作成してくださったIDでログインしていただければされます。',
  },
  affiliate: {
    affiliate_occur_list: '手当発生内訳',
    affiliate_adjust_list: '手当精算内訳',
    allowance_balance_asset: '資産別手当残高',
    list_allowance_balance_asset: '資産別手当残高リスト',
    search_by_asset: '資産別検索',
    allowance_search: '手当対象検索',
    generator: '発生者',
    beneficiary: '受益者',
    benefactor: '恩恵者',
    behavior_type: '行動タイプ',
    target_unique_number: '対象固有の番号',
    date_of_occurrence: '発生日',
    application_policy_name: '適用ポリシー名',
    beneficiary_type: '受益者のタイプ',
    benefactor_type: '恩恵者タイプ',
    target_amount: 'ウォン金額対象',
    principal_amount: 'ウォン金額',
    allowance: '手当',
    allowance_assets: '手当資産',
    allowance_amount: '手当額',
    affiliate_log: '手当の内訳',
    allowance_settlement: '手当精算',
    allowance_settlement_info: '手当精算情報',
    name_asset_settled: '手当精算される資産人',
    balance_receive_payment: '手当精算される残高',
    select_account_settled: '精算される口座の選択',
    no_affiliate_log: '手当発生内訳はありません。',
    no_affiliate_balance: '資産別手当残高一覧がありません。',
    no_affiliate_adjust: '手当精算内訳がありません。',
    asset_name: '資産人',
    asset_code: '資産コード',
    balance: '残高',
    cumulative_amount: '累積金額',
    please_select_account: '口座を選択してください。',
    calculate: '精算',
    settle: '精算する',
    calculate_amount: '精算金額',
    account_number: '口座番号',
    registration_date: '登録日',
    number: '番号',
  },
  Coin_name: 'コイン名',
  main_function: '主な機能',
  disclosure_ing: '公示中',
  market_balance_transfer: '市場残高振替',
  available_after_login: 'ログイン後に使用可能です。',
  fast_stable_deal: '迅速かつ安定的な取引で共にする',
  cryptocurrency_exchange: '暗号通貨取引所',
  go_transaction: '取引に行く',
  create_an_account: 'アカウントの作成',
  more_than_that: 'はそれ以上の価値がある。',
  vision_title: '信頼ベースのビジョン',
  vision_text1:
    'ONEWORLDPAYは、新しいデジタル資産エコシステムでブロックチェーンテクノロジーを使用しています。',
  vision_text2: '信頼ベースのビジョン',
  Fee_title: '手数料優待',
  Fee_text1: 'アカウント登録時手数料免除、アカウントメインテナンス費用免除',
  Fee_text2: '購買/販売手数料を免除します。',
  row_title: '参入障壁が低い',
  row_text1: 'ビットコイン、イーサリアムなど',
  row_text2: '取引することができます。',
  easy_title: '快適なインターフェース',
  easy_text1: '初心者でも誰でも簡単に取引することができる簡単な取引',
  easy_text2: 'インタフェースを提供します。',
  full_time: 'フルタイムトランザクション',
  full_time_text1:
    'いつでもどこでも携帯電話とコンピュータがあれば、1年365日24時間',
  full_time_text2: '取引が可能です。',
  easy_sellbuy: 'いつでもどこでも便利な取引',
  so_easy: '簡単楽',
  b2c_mobile: 'B2Cモバイルアプリ',
  app_sellbuy: 'アプリを介してモバイルデバイスと取引する場合',
  anywhere_use: 'いつでもどこでもB2Cとすることができます。',
  now_start_buy: '今すぐ取引を開始してください。',

  procedure:
    'ONEWORLDPAY.COM/COCOBNK.COM接続後のログインする時、情報共有のための承認手続きが行われ、その手順は、SNSのログイン（ソーシャルログイン）のための必要な手順です。 SNSをログインしなければ、ONEWORLDPAY / COCOBNKログインが不可能であり、その手順は、情報通信網法及び個人情報保護法に基づいて行われる手順です。',
  snslink: 'SNSアカウント連動状態で要求されたログイン、情報通信網法について',
  four_one:
    '第4条①科学技術情報通信部長官又は放送通信委員会は、情報通信網の利用促進及び安定的管理運営と利用者保護等（以下「情報通信網利用促進及び情報保護等」という。）を介して情報社会の基盤を造成するための施策を講じなければならない。',
  four_two:
    '②第1項の規定による施策には、次の各号の事項が含まれなければならない。  ',
  eight: '8.情報通信網の安全性と信頼性の向上',
  nine: '9.その他の情報通信網利用促進及び情報保護などのために必要な事項',
  execution: '当該条項に基づいて実施されています',
  privacy: 'また、個人情報保護法について',
  twentyfour_three:
    '第24条（固有の識別情報の処理制限）③個人情報の処理者が第1項各号に基づいて固有の識別情報を処理する場合には、その固有の識別情報が紛失⠂盗難⠂流出⠂偽造⠂変調または毀損されないように大統領令で定めるところにより、暗号化などの安全性の確保に必要な措置をしなければならない。',
  twentyfour_two:
    '第24条の2（住民登録番号の処理の制限）②個人情報の処理は、第24条第3項の規定にかかわらず、住民登録番号が紛失⠂盗難⠂流出⠂偽造⠂変調または毀損されないように暗号化措置を通じて安全に保管しなければならない。この場合、暗号化対象と対象別の適用時期等に関して必要な事項は、個人情報の処理規模と流出時の影響等を考慮して、大統領令で定める。',
  implemented: '当該条項に基づいて実施されています',
  we_future: '私たちの未来',
  pop_cocobank: 'ココ銀行',
  fourth_industry: '第4業界のリーダー',
  oc_15: '10月15日',
  officially_open: '正式オープン！',
  head_branch_office: '韓国本店（蚕室支店）/第一支店（新沙支店）',
  sep_15: '9月15日午後5時',
  open_popup: 'オープン',
  thanks_for: '声援に感謝いたします。',

  kiosk: {
    make_pay: '決済する',
    product_name: '商品名',
    amount_payment: '決済金額',
    may_pay_guide_txt:
      '<span style="font-weight:900; color:#2369b0;">ONEWORLDPAY {os}の決済QRコード</span> を端末にスキャンすると決済完了します。',
    app_download_btn: 'ONEWORLDPAY {os} 設置',
    app_download_qr_scan:
      'アプリのダウンロードを 希望する場合には、 QRコードをスキャンしてください。',
    app_install_txt:
      '下のQRコードをスキャンして <span style="font-weight: 900; color: #1f67af">ONEWORLDPAY {os}</span> を設置してください。',
    app_install_sub_txt:
      'ONEWORLDPAY決済ページQRコードを<br />端末にスキャンすると決済が進まれます。',
    app_install_sub_txt2: 'ONEWORLDPAY iosサービスは後日提供になります。',
    direct_exchange_txt:
      '<strong>{asset1}</strong><span>を</span> <strong>{asset2}</strong><span>に</span> <strong>交換</strong><span>します。</span>',
    bank_use: 'バンクのご利用',
    cocobank: 'ONEWORLDPAY',
    cocobank_account_transfer: 'ONEWORLDPAY口座振り込み',
    store_use: '注文',
    location_store: 'co.u co.u',
    home_ad_1: '世界初のコインオープンマーケット',
    home_ad_2: 'COCO MARKET',
    use: '使い方',
    bank_direct_ex: 'すぐに両替します',
    deposit_inquiry: '預金照会',
    deposit_inquiry_txt: 'ONEWORLDPAY口座内訳を照会',
    deposit_withdrawal: '預金出金',
    deposit_withdrawal_txt: 'お申込み後、10秒～10分かかります。',
    deposit_transfer: '預金送金',
    deposit_transfer_txt: 'ONEWORLDPAY口座間送金',
    wallet_transfer: '外部送金',
    wallet_transfer_txt: '外部へ送金',
    exchange_list: '両替内訳',
    certified: '認証管理',
    certified_drawer_title: '認証管理',
    direct_transaction: 'ダイレクト両替',
    direct_transaction_txt: 'すぐ両替します。',
    c2c_transaction: 'C2C取引',
    c2c_transaction_txt: '顧客間暗号通貨取引をします。',
    account_application: '口座開設',
    account_application_txt: '口座を開設します。',
    // account application comonent
    terms_title1: '電気通信金融詐欺被害予防をための限度制限案内',
    terms_text1:
      '要求払口座が非対面で開設され自動化機器、インターネットを通じた引き出し(振り込み)限度は１日０CCFに制限されます。<br>取引目的が確認できる客観的な認証資料を支店に提示するか「管理→セキュリティ認証/管理」で限度制限が解除できます。<br>インターネットバンキングサービスを利用する時、出金口座に登録してから振り込み取引ができます。<br>暗号通貨別限度制限口座は一人５個まで開設できます。',
    terms_notice1: '注意事項',
    terms_notice1_txt:
      'インターネットバンキング加入は入出金口座を開設した後、完了画面で連動して申請することができます。<br>既存のインターネットバンキング加入顧客は出金口座登録区分がインターネット＋支店になっている場合にのみ、<br>インターネットバンキングで出金口座登録を行うことができていることに注意してください。',
    terms_notice2:
      '&#8251; セキュリティ認証を先に行って進行すると口座を作り、インターネットバンキング利用時出金口座に登録してから振り込み取引が可能です。',
    cancel: 'キャンセル',
    security_authentication: 'セキュリティ認証',
    new_registration: '新規登録',
    terms_title2:
      '新しいサインアップボタンをクリックすると、外部ウォレットにリンクされた独自の{0}Cocobankアカウントと預金アドレスが発行されます。',
    terms_notice3: '入金する前に必ず知っておいてください！',
    terms_notice3_text1:
      '新規登録時に発行された口座/住所に預金できるのは{0}のみです。他のデジタル資産をその住所に預けようとした場合に発生する可能性のあるエラー/損失は回復不能です。',
    terms_notice3_text2:
      '1回の確認が行われた後、それは入金プロセスを通じて残高に反映されます。入金プロセスは自動で行われ、必要な時間はネットワークの状態によって異なる場合があります。',
    terms_notice3_text3: '上記の住所は<strong>デポジットのみ</ strong>です。',
    terms_checkbox_text: '上記に同意し、理解しましたか？',
    assets: '資産',
    favorite: 'お気に入り',
    select_assets_txt: '資産を選択してください。',
    search_assets: '資産検索',
    search_assets_txt: '資産を検索してください。',
    account_name: '口座名',
    account_name_txt: '口座名を入力してください。',
    selected_assets: '選択資産',
    account_unique_number: '口座固有番号',
    account_number: '口座番号',
    stop_amount: '停止金額',
    state: '状態',
    auto_input: '自動入力',
    opening: '開設',
    application_success_txt: '口座開設が完了しました。',
    application_fail_text: 'アカウントの申請に失敗しました。',
    confirm: '確認',
    previous: '前',
    enter_account_number: '口座番号を入力して下さい。',
    service_preparation: 'サービス準備中です',
    service_preparation_txt1:
      'より良いサービス提供のためにページ準備中にあります。',
    service_preparation_txt2: '早いうちに準備してお伺いします。',
    search_account: '口座検索',
    search_account_txt: '口座を検索してください',
    select_account_txt: '口座を選択してください。',
    withdrawable_amount: '出金可能金額',
    inquiry_period: '照会期間',
    variable_amount: '変動金額',
    no_deposit_history: '預金照会内訳がありません。',
    select_date: '日付を選択してください',
    type_of_change: '変動類型',
    sort_order: '序列順',
    inquiry_option: '照会オプション',
    select_market: 'マーケット選択',
    reduction_rate: '手数料率',
    sales_quantity: '販売数量',
    minimum_purchase_quantity: '最小購買数量',
    selling_price_per_piece: '個当り販売価格',
    account_for_registration_of_sales: '販売登録用口座',
    purchase_assets: '購入資産',
    available_quantity: '可用数量',
    purchase_quantity: '購入数量',
    price_per_piece: '個当り価格',
    quantity_to_be_paid: '支払いしなければならない数量',
    select_account_to_receive: '受ける口座選択',
    registration_was_successful: '登録に成功しました',
    registration_failed: '登録に失敗しました。',
    go_to_first: '初めて',
    purchase_history: '購買内訳',
    purchase_price: '購買価格',
    no_description: '内訳がありません。',
    sales_history: '販売内訳',
    price_per_quantity: '数両当たり価格',
    total_fee: '手数料合計',
    no_disclosure_details: '公示内訳がありません',
    advanced_search: '詳細検索',
    sales_registration: '販売登録',
    purchase_registration: '購買登録',
    verification_completed: '認証完了',
    email_authentication: 'Eメール認証',
    authenticate: '認証する',
    identity_verification: '本人認証',
    otp_authentication: 'OTP認証',
    withdrawal_address_verification: '出金アドレス認証',
    withdrawal_address_application_details: '出金住所申請内訳',
    no_withdrawal_address_application_details: '出金住所申請内訳がありません',
    kyc_authentication: 'KYC認証',
    kyc_application_details: 'KYC申請内訳',
    security_level: 'セキュリティレベル',
    view_rating: 'レベルをみる',
    no_account_alias: '(口座別称なし)',
    no_choice: '(選択なし)',
    select_coin_to_exchange:
      '<strong>両替</strong><span>対象の</span><strong>コイン</strong><span>を選択してください。</span>',
    sending_verification_email: '認証メール発送する',
    sending_verification_email_txt: '認証メール発送することを押してください。',
    enter_verification_code: '認証する',
    enter_verification_code_txt: '認証コードを入力してください',
    verification_email_has_been_sent: '認証メールが発送されました',
    base_asset_account_information: '基準資産口座情報',
    classification_of_transactions: '取引区分',
    logged_out_txt: 'ログアウトなりました。',
    check_logged_out_txt: 'ログアウトしまうか。',
    scan_qr_code_txt: '下のQRコードをスキャンしてください。',
    simple_login: '簡単ログイン',
    simple_login_txt: '簡単ログイン認証コードを入力してください',
    be_loggin_in: 'ログイン中です',
    be_logged_in: 'ログインされました',
    step_one: '1段階',
    step_one_txt: 'OTP認証のためにApp StoreでGoogle OTPを設置してください。',
    step_two: '2段階',
    step_two_txt:
      '発給された16桁コードを出力するとか書き留めてほしいです。 このコードは携帯電話紛失/交替及び削除時復旧のために使われます。',
    step_three: '3段階',
    step_three_txt:
      '設置したGoogle Authenticarorアプリで下QRコードをスキャンしてください。',
    step_four: '4段階',
    step_four_txt:
      '<strong>生成されたOTP 6桁数字認証コード</strong>を入力後認証することを押してください。',
    mobile_authentication: '携帯電話認証',
    mobile_authentication_txt: '本人名義の携帯電話を利用して認証を進めます。',
    do_mobile_authentication: '携帯電話認証する',
    complete_mobile_authentication: '認証が完了しました',
    failed_mobile_authentication: '認証を失敗しました。',
    transfer_quantity: '振り込み数量',
    enter_transfer_quantity: '振り込み数量を入力してください。',
    transfer_quantity_2: '外部送金数量',
    enter_transfer_quantity_2: '外部送金数量を入力してください。',
    select_transfer_quantity: '振り込み数量を選択してください。',
    enter_transfer_account_number: '振り込み口座番号を入力してください。',
    current_security_level: '会員様の現在のセキュリティ等級',
    choose_how_to_pay_the_fee: '手数料支払い方法選択',
    confirm_withdrawal_application_information: '出金申請情報確認',
    enter_login_code_txt:
      'ログイン後、画面に表れた簡単ログイン<br />認証コードを下欄にご入力してください。',
    direct_ex_manual: 'ダイレクト両替の使用方法',
    deposit_transfer_manual: '預金送金使用方法',
    deposit_inquiry_txt_manual: '預金照会を使用方法',
    deposit_withdrawal_manual: '預金引き出しの使用方法',
    wallet_transfer_manual: '財布変形の使用方法',
    buy_with_coin_selected_account: '選択した口座から{code}で購買します。',
    sell_with_coin_selected_account: '選択した口座から{code}を販売します。',
    receive_purchased_coin: '購買した{code}をもらう口座を選択します。',
    receive_converted_coin: '両替した{code}をもらう口座を選択します。',
    enter_account_holder: '預金主の姓名を入力してください。',
    enter_account: '口座番号を入力して下さい。',
    enter_withdrawal: '出金金額を入力してください。',
    transfer_to_another_wallet: '外部へ送金',
    invalid_login_code: '無効なログイン認証コードです。',
    payment_canceled: '支払いがキャンセルされました',
  },

  market_balance: {
    deposit_successful: '入金は成功しました。',
    wthdrawal_successful: '撤退は成功しました。',
    deposit: '預り金',
    withdrawal: '引き出し',
    select_account: 'アカウントを選択',
    assets: '資産',
    select_market: '市場の選択',
    quantity: '量',
    confirm: '確認',
  },
  pop_notice: {
    notice_close: '閉じる',
    notice_today: '今日一日見ない',
  },
  private_notice: {
    msg_false_deal_title: '虚偽公示禁止',
    msg_false_deal_content_1:
      '売り手は必ず販売に必要な暗号通貨を十分に保有して取引を行ってください。',
    msg_false_deal_content_2:
      '虚偽公示を持続的に行った場合にはサービス利用に制限がかかることに留意してください。',
    msg_deal_confirm_click_title: '確定ボタンをクリックする時の注意事項',
    msg_deal_confirm_click_content_1:
      '売り手は買い手の支払可否を確認した後、必ず「確定」ボタンをクリックする必要があります。',
    msg_deal_confirm_click_content_2:
      '売り手の不注意が原因で発生する金銭的損害についてココバンクは法的に責任がありません。 必ず買い手の支払可否を確認してください。',
    msg_deal_confirm_not_click_title: '確定ボタンを押さなかった時',
    msg_deal_confirm_not_click_content_1:
      '売り手は買い手の支払いかどうかを確認した後、必ず「確定」ボタンをクリックする必要があります。',
    msg_deal_confirm_not_click_content_2:
      '「確定」ボタンをクリックしなかった場合、管理者によりサービス利用に制限がかかることに留意してください。',
    msg_c2c_title: 'C2C取引',
    msg_c2c_content_1:
      'C2Ct取引は、買い手と売り手の自由な取引活動に基づいています。',
    msg_c2c_content_2:
      'ONEWORLDPAYは買い手と売り手の便利かつ安全な取引のためのフラットフォームサービスだけを提供します。',
    msg_c2c_content_3:
      '買い手と売り手間の法的紛争が発生した時に、ONEWORLDPAYはエスクローとしての役割だけを担っていることを留意してください。',
    msg_false_hold_title: '虚偽ホールディング禁止',
    msg_false_hold_content_1:
      'バイヤーは必ず該当C2C取引の支払いが完了した後に「ホールディング」をクリックする必要があります。',
    msg_false_hold_content_2:
      '虚偽ホールディングに起因する売り手と買い手との間の紛争は、ココバンクでは責任を負いません。',
    msg_false_hold_content_3:
      'また、虚偽のホールディングを継続的に行う時のサービス利用に制限が加えられ荷物を注意してください。',
    msg_false_hold_content_4:
      '支払いが完了した後に確定されていない場合には、1対1のお問い合わせを通じて管理者にお問い合わせください。',
    msg_false_hold_content_5:
      '外部財布を介してC2C取引を行う場合には、手数料がかかる場合がありC2C取引正常に行われない場合は、取引の解決に不快感がある場合があります。',
  },
  kiosk_re: {
    choice_lang: '言語選択',
    buy_immedi:
      'ココバンクをご利用すると<br><span>すぐにお買い求め</span>いただけます。',
    new_acc: 'ココバンク口座開設',
    join_txt:
      '外部の財布及び口座をご利用の際には購入予約をして販売者の確認有無が必要ですが、ココバンクをご利用いただけましたら直ちにご購入いただけます。ココバンク内での移動の際、手数料を頂かず、世界で最も早い暗号資産間の移動をサポートしています。',
    main_order_txt: 'クレジットカード/暗号資産 ストアで決済',
    main_bank_txt: '暗号資産を安全に保管及び購入/販売',
    main_market_txt: 'オンライン暗号資産オープンマーケット',
    main_about: 'コインアバウト',
    main_about_txt: '暗号資産に関する専門ニュース',
    about_drw_txt_1:
      '迅速かつ多様なブロックチェーンのお知らせを<br><span>coinabout</span>で受け取ってください。',
    about_drw_txt_2:
      'コインアバウトはブロックチェーンとフィンテックに<br>関する迅速なニュースと分析をご提供致します。',
    about_drw_txt_3: 'QRコードをスキャンするとコインアバウトに接続できます。',
    market_drw_txt_1:
      'これから<span>仮想資産でショッピング</span>してください。',
    market_drw_txt_2:
      'ココマーケットは、国内初の仮想資産で<br>商品を売買することができるオープンマーケットです。',
    market_drw_txt_3:
      'QRコードをスキャンすると、ココマーケットに接続できます。',
    market_drw_txt_4:
      'ココマーケットは今後、多くの商品と様々な仮想資産の<br>決済システムを構築する予定です。',
    login_title: '下の <span>QR コード</span>をスキャンしてください。',
    login_txt_1: 'サービスご利用のためのユーザー情報が必要です。',
    login_txt_2:
      '端末画面に表示された簡単ログイン認証コードを以下の入力欄に入力してください。',
    code_txt: '簡単ログイン<br> <span>認証コード</span>を入力してください。',
    new_acc_tit_1: '新規口座開設',
    new_acc_tit_2: '新規口座開設に必要な内容を確認してください。',
    new_acc_txt_1: '電気通信金融詐欺被害予防のための限度制限のご案内',
    new_acc_txt_2:
      '* インターネットバンキングで振り込み取引をより簡単に行うためには、セキュリティ認証を行う必要があります。認証ステップを通してレベルを向上させた後、口座開設及び出金口座登録を行ってください。',
    new_acc_txt_3:
      'ココバンク専用の口座から口座へ送金すると手数料が一切かかりません。新規登録時に発行される口座/アドレスには{0}のみ入金可能です。該当するアドレスに別のデジタル資産種類を入金する場合に発生するエラー/損失は復旧できません。1回の確認作業が行われた後、入金プロセスを経て残高に反映されます。入金プロセスは自動的に行われ、ネットワークの状況によって所要時間が異なることがあります。上記のアドレスは、入金専用のアドレスです。',
    new_acc_txt_4:
      '会員様に割り当てられた新規登録では、{0}を入金することができます。',
    new_acc_btn_agr: '同意及び口座開設',
    new_acc_txt_5: '新規口座の開設ができました。',
    new_acc_txt_6: '開設できた口座でココバンクサービスがご利用できます。',
    charge_tit_1: '{0}をチャージします。',
    charge_tit_2: '{0}チャージに使われる資産を選択してください。',
    charge_tit_3:
      '口座選択及びチャージに使わせる資産数量をご入力してください。',
    charge_txt_1: 'チャージ基準レート',
    charge_txt_2: 'チャージタイプ',
    charge_txt_3: '基準数量',
    charge_txt_4: 'チャージ総額',
    charge_txt_5: 'チャージする',
    charge_txt_6: 'チャージが完了しました。',
    charge_txt_7: '3秒後、メイン画面に戻ります。',
    complete: '選択完了',
    input_complete: '入力完了',
    quan_max: '最大',
    buy_reserv: '購入予約締結',
    krw_dialog_tit: 'ご入金の上、購入予約締結ボタンをクリックしてください。',
    krw_dialog_txt_1:
      '購入予約をクリックすると、ウォレット及び口座は凍結されます。また、購入者が以下のウォレット及び口座へ支払うべき金額を入金した後、最終的に購入予約締結ボタンをクリックすると、販売者にその内容が通知されます。そして、販売者が購入確認をした瞬間、購入者のウォレット及び口座に購入した資産が入金されます。',
    krw_dialog_txt_2:
      '* 3時間以内に購入予約が締結できなかった場合、凍結されたウォレット及び口座は使用可能になります。ただし、入金して1時間から2時間以内に資産が口座に入ってこない場合には、顧客センターにご連絡ください。',
    krw_dialog_txt_3:
      '購入者は予約だけして入金が3回以上されないとIDが停止されます。',
    purchase: '購入資産',
    payable: '支払資産',
    purchase_choice: '購入資産選択',
    payable_choice: '支払資産選択',
    latest_order: '最新順',
    low_price: '低い価格順',
    high_price: '高い価格順',
    seller: '販売者',
    search_seller: '販売者を検索してください。',
    no_regist: '登録販売商品が見つかりません。',
    other_seller: '他の販売者を検索してください。',
    pur_quan: '購入数量',
    buy_quan: '支払数量',
    bank_txt_1:
      '上の <span class="color-blue">購入資産</span>と <span class="color-green">支払資産</span>を<br /> 選択すると購入リストの確認ができます。',
    sale_regist: '販売公示を登録する',
    bank_drw_tit: '販売公示登録',
    bank_drw_txt_1: '販売公示登録はモバイルで登録することができます。',
    bank_drw_txt_2: 'QRコードをスキャンすると販売公示登録ページに移動します。',
    total_charge: '最終チャージ数量',
    detail_tit: '<strong>購買情報</strong>を確認してください。',
    detail_sub: '購入に必要な口座を選択してください。',
    pur_assets: '購入資産',
    acc_receive: '受け取る口座選択',
    seller_acc_info: '販売者口座情報',
    krw_txt: 'ココバンクはKRW(韓国ウォン)を入金又は保存しません。',
    total_payble: '最終支払資産',
    purch_reser: '購入予約',
    buy: '購入する',
    buy_suc: '購入完了しました。',
  },
}
